export default "__VITE_ASSET__D12v2T8D__"